import { PersonnelType } from '@core/data-access';

export type AccessTokenPayload = Partial<{
  issuerName: string;
  uuid: string;
  caseId: number;
  personnelId: number;
  type: PersonnelType;
  iat: number;
  exp: number;
}> | null;
